/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_sole = /** @type {(inputs: {}) => string} */ () => {
	return `Podrážka`
};

const da_attributes_sole = /** @type {(inputs: {}) => string} */ () => {
	return `Skosål`
};

const de_attributes_sole = /** @type {(inputs: {}) => string} */ () => {
	return `Sohle`
};

const en_attributes_sole = /** @type {(inputs: {}) => string} */ () => {
	return `Sole`
};

const es_attributes_sole = /** @type {(inputs: {}) => string} */ () => {
	return `Suela`
};

const fr_attributes_sole = /** @type {(inputs: {}) => string} */ () => {
	return `Semelle`
};

const hu_attributes_sole = /** @type {(inputs: {}) => string} */ () => {
	return `Egyetlen`
};

const it_attributes_sole = /** @type {(inputs: {}) => string} */ () => {
	return `Suola`
};

const nl_attributes_sole = /** @type {(inputs: {}) => string} */ () => {
	return `Schoenzool`
};

const pl_attributes_sole = /** @type {(inputs: {}) => string} */ () => {
	return `Podeszwa`
};

const pt_attributes_sole = /** @type {(inputs: {}) => string} */ () => {
	return `Sola`
};

const sv_attributes_sole = /** @type {(inputs: {}) => string} */ () => {
	return `Sula`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_sole = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_sole(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_sole", locale)
	if (locale === "cs") return cs_attributes_sole(inputs)
	if (locale === "da") return da_attributes_sole(inputs)
	if (locale === "de") return de_attributes_sole(inputs)
	if (locale === "en") return en_attributes_sole(inputs)
	if (locale === "es") return es_attributes_sole(inputs)
	if (locale === "fr") return fr_attributes_sole(inputs)
	if (locale === "hu") return hu_attributes_sole(inputs)
	if (locale === "it") return it_attributes_sole(inputs)
	if (locale === "nl") return nl_attributes_sole(inputs)
	if (locale === "pl") return pl_attributes_sole(inputs)
	if (locale === "pt") return pt_attributes_sole(inputs)
	return sv_attributes_sole(inputs)
};
export { attributes_sole as "attributes.sole" }